import React, { useState, useEffect } from 'react';
import { TextField, Box, Button, 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    FormControlLabel, RadioGroup, Radio,
    MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { de, enGB } from 'date-fns/locale';
import FlexBetween from 'components/FlexBetween';


const CrewFilterDialog = ({ open, onClose, onApply, genderOptions, isActiveOptions, currentFilters }) => {
    const locales = { 'en-us': undefined, 'en-gb': enGB, de };
    const [cleared, setCleared] = React.useState(false);
        
    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => {};
    }, [cleared]);

    const initialValues = {
        staffCode: '', 
        staffName: '',
        birthDay: null,   
        gender: 'ALL',
        contactTel: '',    
        email: '',    
        isActive: 'ACTIVE',
    };

    const [filterValues, setFilterValues] = useState(() => {
        if (!currentFilters) return initialValues;
        return {
            ...initialValues,
            ...currentFilters,
            gender: currentFilters.gender ?? 'ALL',
        };
    });

    const handleDateChange = (date) => {
        setFilterValues(prev => ({ ...prev, birthDay: date }));
    };

    const handleFilterChange = (field) => (event) => {
        const value = event.target.value;
        setFilterValues(prev => ({
            ...prev,
            [field]: value, 
        }));
    };

    const handleIsActiveChange = (event) => {
        setFilterValues(prev => ({
            ...prev,
            isActive: event.target.value, 
        }));
    };

    const handleApply = () => {
        const { gender, isActive } = filterValues;    
        const comboFilters = {
            gender: gender === 'ALL' ? null : gender,
            isActive: isActive || 'ACTIVE', 
        };
    
        const appliedFilters = {
            ...filterValues,
            ...comboFilters,
        };
    
        onApply(appliedFilters);
        onClose();
    };   
    
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleApply();
        }
    };

    const handleCancel = () => {
        setFilterValues(initialValues);  
        onApply(null);
        onClose();  
    };
    

    return (   
        <LocalizationProvider 
            dateAdapter={AdapterDateFns}
            adapterLocale={locales['en-gb']}
        >     
            <Dialog 
                open={open} 
                onClose={handleCancel}
                sx={{ '& .MuiDialog-paper': { minWidth: '40%' } }}
            >
                <DialogTitle>
                    Filter
                </DialogTitle>
                <DialogContent onKeyDown={handleKeyPress}>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <FlexBetween
                            gap={2}
                            sx={{ marginTop: '6px' }}
                        >         
                            <TextField
                                label="Staff Code"
                                value={filterValues.staffCode}
                                onChange={handleFilterChange('staffCode')}
                                sx={{ width: '40%' }}
                            />                   
                            <TextField
                                fullWidth
                                label="Staff Name"
                                value={filterValues.staffName}
                                onChange={handleFilterChange('staffName')}
                            />                            
                        </FlexBetween> 

                        <FlexBetween gap={2}>     
                            <DatePicker
                                label="Birth Date"
                                value={filterValues.birthDay}
                                onChange={handleDateChange}
                                format="dd/MM/yyyy"
                                sx={{ width: '50%' }}
                                slotProps={{
                                    field: { clearable: true, onClear: () => setCleared(true) },
                                }}
                            />
                                                    
                            <FormControl sx={{ width: '50%' }}>
                                <InputLabel>Gender</InputLabel>
                                <Select
                                    label="Gender"
                                    value={filterValues.gender}
                                    onChange={handleFilterChange('gender')}
                                >
                                    <MenuItem value="ALL">ALL</MenuItem>
                                    {genderOptions.map((gender, index) => (
                                        <MenuItem key={index} value={gender}>{gender}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>                                                                                 
                        </FlexBetween>   

                        <FlexBetween gap={2}> 
                            <TextField
                                label="Contact Tel"
                                value={filterValues.contactTel}
                                onChange={handleFilterChange('contactTel')}
                                sx={{ width: '40%' }}
                            />
                            <TextField
                                fullWidth
                                label="Email"
                                value={filterValues.email}
                                onChange={handleFilterChange('email')}
                            />
                        </FlexBetween>  
                        {isActiveOptions && (
                            <Box>                            
                                <RadioGroup
                                    value={filterValues.isActive}
                                    onChange={handleIsActiveChange}
                                    row
                                >
                                    <FormControlLabel value="ALL" control={<Radio />} label="All" />
                                    <FormControlLabel value="ACTIVE" control={<Radio />} label="Active" />
                                    <FormControlLabel value="INACTIVE" control={<Radio />} label="Inactive" />
                                </RadioGroup>
                            </Box>
                        )}                                  
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined"
                        color="secondary"
                        onClick={handleCancel} 
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="outlined"
                        onClick={handleApply} 
                    >
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
};

export default CrewFilterDialog;
